import { render, staticRenderFns } from "./UpChevronIcon.vue?vue&type=template&id=0cf0406f&"
import script from "./UpChevronIcon.vue?vue&type=script&lang=js&"
export * from "./UpChevronIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports